import { FolderView } from './FolderView';

export class FolderNewView {
  folders: Array<FolderView>;
  isLoading: boolean;
  canSubmit: boolean;

  constructor(params: FolderNewViewParams) {
    this.folders = params.folders;
    this.isLoading = params.isLoading;
    this.canSubmit = params.canSubmit;
  }
}

export type FolderNewViewParams = {
  folders: Array<FolderView>;
  isLoading: boolean;
  canSubmit: boolean;
};
